import { render, staticRenderFns } from "./PaymentFormBillingAddress.vue?vue&type=template&id=36e96702&"
import script from "./PaymentFormBillingAddress.vue?vue&type=script&lang=js&"
export * from "./PaymentFormBillingAddress.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFormBillingAddress.vue?vue&type=style&index=0&id=36e96702&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports